import React, { ReactNode } from 'react';
import { Button as DefaultButton, Spinner } from 'react-bootstrap';
import { ButtonVariant } from 'react-bootstrap/types';
import { ButtonType } from 'react-bootstrap/Button';
import classNames from 'classnames';

interface Props {
    children: ReactNode | string;
    disabled?: boolean;
    variant: ButtonVariant;
    type?: ButtonType;
    onClick?: () => void;
    className?: AnyObject | string;
    loading?: boolean;
}

const Button = ({ loading = false, children, className, variant, disabled, ...rest }: Props) => {
    return (
        <DefaultButton variant={variant} disabled={disabled} className={classNames(className)} {...rest}>
            {loading && (
                <>
                    <Spinner as="span" variant="light" size="sm" role="status" aria-hidden="true" animation="border" />{' '}
                </>
            )}
            {children}
        </DefaultButton>
    );
};

export default Button;
